var o="1.10.0";export{o as a};
//# sourceMappingURL=chunk-GSLZL2LN.mjs.map